module.exports = __webpack_public_path__ + "img/landing_body_3.fc52202d.png";